module.exports = __webpack_public_path__ + "static/img/08.7af38e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20241216_2/08.png
// module id = Osld
// module chunks = 0